import { Building2, Clock3, MapPinned, UserRound } from 'lucide-react';

import type { TimelineItem } from '../../../shared/dashboard-data';

interface TimelinePanelProps {
  items: TimelineItem[];
}

export function TimelinePanel({ items }: TimelinePanelProps) {
  return (
    <section className="panel matte-frame timeline-panel">
      <h2 className="panel-title">养护日志列表</h2>

      <ul className="timeline-list">
        {items.map((item) => (
          <li key={item.id} className="timeline-item">
            <span className="timeline-node" />
            <div className="timeline-card">
              <div className="timeline-head">
                <div className="timeline-time">
                  <Clock3 size={14} strokeWidth={2.2} />
                  <span>{item.timeText}</span>
                </div>
                <span className="timeline-badge">养护动态</span>
              </div>

              <div className="timeline-meta-grid">
                <span className="timeline-chip">
                  <UserRound size={13} strokeWidth={2} />
                  <span className="timeline-chip-label">负责人：{item.leader}</span>
                </span>
                <span className="timeline-chip">
                  <MapPinned size={13} strokeWidth={2} />
                  <span className="timeline-chip-label">{item.zoneName}</span>
                </span>
                <span className="timeline-chip">
                  <Building2 size={13} strokeWidth={2} />
                  <span className="timeline-chip-label">{item.maintenanceUnit}</span>
                </span>
              </div>

              <div className="timeline-desc">{item.description}</div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
